import { render, staticRenderFns } from "./gender-icon-component.vue?vue&type=template&id=4f697a0f&scoped=true"
import script from "./gender-icon-component.ts?vue&type=script&lang=ts&external"
export * from "./gender-icon-component.ts?vue&type=script&lang=ts&external"
import style0 from "./gender-icon-component.scss?vue&type=style&index=0&id=4f697a0f&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f697a0f",
  null
  
)

export default component.exports